/**
 * Reports route changes to product analytics using a sanitized route shape
 * (ids collapsed, no query/hash) instead of the raw URL. This is the only
 * page-view source — automatic URL capture is disabled in mixpanel init.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { mixpanel, sanitizeRoutePath } from '@/lib/analytics/mixpanel';

export function RouteAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    mixpanel.trackPageView(sanitizeRoutePath(location.pathname));
  }, [location.pathname]);

  return null;
}
